import React from "react"

const s3URL = "https://navidad-pyme-assets-dev.s3.amazonaws.com"

const Image = ({ url, className, alt, ...delegated }) => {
  return (
    <picture className={className}>
      <source
        srcSet={`${s3URL}/webp/${url}.webp`}
        type="image/webp"
        {...delegated}
      />
      <img
        src={`${s3URL}/png/${url}.png`}
        {...delegated}
        alt={alt}
        className="shadow-md rounded-lg bg-white"
        width={150}
        height={150}
        loading="lazy"
        // onError={handleError}
      />
    </picture>
  )
}
export default Image
